<template>
  <div v-reportView:toast="{ actiontype: 1, toast: 'set', click: 0 }" class="tools_setting_content">
    <div class="cache_box">
      <div class="cache_size">
        <h5 class="label">缓存大小：</h5>
        <p class="value">{{ cacheSize || '0B' }}</p>
      </div>
      <div>
        <Button class="cache_btn" @click="openCacheDir">缓存目录</Button>
        <Button @click="clearCache">清除缓存</Button>
      </div>
    </div>

    <div class="sys_switch">
      <p>Office办公模板插件（重启Office后生效）</p>
      <div class="switch_box">
        <SwitchCheckbox v-model="switchFlag" @getState="setSwitchState" />
        <span class="switch_font">{{ switchFlag ? '开启' : '关闭' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/index.vue'
import SwitchCheckbox from '@/components/Checkbox/SwitchCheckbox.vue'

import { bytesToSize } from '@shared/utils/base'

import {
  ClientGetCacheSize, ClientOpenCachePath, ClientClearCache,
  ClientSetOfficeAddIn, ClientGetOfficeAddIn
} from '@/api/clientApi.js'
import { report } from '@/report/index.js'

export default {
  name: 'ToolsSetting',

  components: { Button, SwitchCheckbox },

  data () {
    return {
      switchFlag: true,
      cacheSize: ''
    }
  },

  created () {
    this.getCacheSize()
    this.getSwitchState()
  },

  methods: {
    getCacheSize () {
      ClientGetCacheSize().then(obj => {
        const sizeObj = bytesToSize(obj.size || 0)
        this.cacheSize = sizeObj.size + sizeObj.unit
      })
    },

    openCacheDir () { ClientOpenCachePath() },

    clearCache () {
      ClientClearCache(() => {
        this.getCacheSize()
        this.$toast({ desc: '缓存清除成功！' })
      })
    },

    getSwitchState () {
      ClientGetOfficeAddIn((res) => {
        const flag = res.hide
        this.switchFlag = !flag
      })
    },

    setSwitchState (flag) {
      report('toast', { actiontype: 2, toast: 'set', click: flag ? '0' : '1' })
      ClientSetOfficeAddIn(!flag) // false：开启，true: 关闭， 与显示相反
    }
  }
}
</script>

<style lang="scss" scoped>
.tools_setting_content {
  height: 100%;
  padding-left: 24px;

  .cache_box { display: flex; height: 22px; padding-top: 37px; }
  .cache_size {
    display: flex;
    align-items: center;
    margin-right: 20px;
    font-size: 14px;
    font-weight: 400;

    .label { color: $font_color_6; }
    .value { color: $font_color_3; }
  }
  .cache_btn { margin-right: 8px; }

  .sys_switch {
    display: flex;
    align-items: center;
    height: 16px;
    margin-top: 24px;
    font-size: 14px;
    font-weight: 400;
    color: $font_color_6;

    .switch_box {
      display: flex;
      align-items: center;
      margin-left: 14px;

      .switch_font { margin-left: 6px; }
    }
  }
}
</style>
